import Layout from '@/apps/layout/components'
import Quiz from '@/apps/Quiz'
import React from 'react'

const QuizPage = (): React.ReactElement => {
  return (
    <Layout>
      <Quiz />
    </Layout>
  )
}

export default QuizPage
